export default "__VITE_ASSET__crr8cAGQtLha1Cp5BCqX5Q__"